import { render, staticRenderFns } from "./departmentandstaff.vue?vue&type=template&id=6e9968b3&scoped=true&"
import script from "./departmentandstaff.vue?vue&type=script&lang=js&"
export * from "./departmentandstaff.vue?vue&type=script&lang=js&"
import style0 from "./departmentandstaff.vue?vue&type=style&index=0&id=6e9968b3&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e9968b3",
  null
  
)

export default component.exports